/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "SUCCESS": 1,
                          "ERROR": 2,
                          "NO_PROFILE_FOUND": 3,
                          "MISSING_VERSION": 4,
                          "OUTDATED_VERSION": 5,
                          "MERCHANT_MISMATCH": 6,
                          "NOT_MIGRATED": 7,
                          "NO_LINKS_FOUND": 8,
                          "UNIQUENESS_ERROR": 9,
                          "PROFILE_IS_LINKED": 10,
                          "INCOMPATIBLE_PROFILE_TYPE": 11,
                          "MIGRATE_TO_V2": 12,
                          "DEVICE_PROFILE_LINK_MISMATCH": 13
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Status @ squareup/devicesettings/profiles/v2/message/status.proto at 8:1
 */
export const Status = $root.lookupEnum('squareup.devicesettings.profiles.v2.message.Status').values;